// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCApiGatewayServiceClientsEnumsCommunicationType } from './tCApiGatewayServiceClientsEnumsCommunicationType.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersCardModelsExtCardReplaceCardResultModel {
    'replacementDeliveryTypes'?: TCApiGatewayServiceClientsEnumsCommunicationType;
    'memberNumber'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersCardModelsExtCardReplaceCardResultModel>> = [
        {
            "name":     "replacementDeliveryTypes",
            "baseName": "replacementDeliveryTypes",
            "type":     "TCApiGatewayServiceClientsEnumsCommunicationType"
        },
        {
            "name":     "memberNumber",
            "baseName": "memberNumber",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersCardModelsExtCardReplaceCardResultModel.attributeTypeMap;
    }
}
